<p-contextMenu #cm [model]="items" appendTo="body"  triggerEvent="click"></p-contextMenu> 
<div class="col-md-12">
  <div class="col-lg-10 d-flex align-item-center">
    <app-filter-panel [isAddFilter]=false [DefaultFilterArray]="DefaultFilterArray"
      (FilterEvent)="FilterApplyFilterEvent($event)"
      [isDatefilterDropdown]="true">
    </app-filter-panel>
    <div class="group-list d-flex flex-wrap">
      @for(group of groupListDropDown; track group+ '-'+ $index; let i = $index) {
      <a>
        @if(selectedGroup === group){
        <mat-chip class ="chip" selectable="true" [removable]="true" selected [matTooltip]="group.label" matTooltipPosition="after"
          [id]="group" [matTooltipShowDelay]="1000" >
          {{group}}
          <mat-icon matChipRemove id="cat-reconIcon"
                (click)="clearGroup($event)">cancel</mat-icon>
        </mat-chip>}
      </a>}
    </div>
    </div>
  <!-- Analytical Comments -->
  <div class="col-lg-2 pd-t-4 text-center">
    <ng-container>
      <label for="browseCommentLabel" id="browseCommentLabel" class="commentbtnWrapper">
        <p-button id="commentBtn" type="button" class="commentBtn" 
        [ngClass]="'button btn-xs non-active-symbol'" 
        (click)="sendPreparedParams('Browse-Comments', [], '');openCatalystCommentViewer(true, false);">
          Browse Review Comments
        </p-button>
         <span class="btnBadge">{{totalCommentsCount}}</span>
      </label>        
    </ng-container>
  </div>
  <!-- End of Analytical Comments -->
  <br/>
  <div class="col-lg-12 nopadding">
    <div class="ui-widget-header-1 nopadding">
      <div class="ui-grid-col-12 btnPanel">
        <label for="clientncat">
          <button pButton id="clientncat" type="button" [disabled]="false" [ngClass]="(selectedTabIndex === 1 ? 'optedBtnColor' : '')" label="Client & CAT" (click)="getOptedTab(1, 'Client & CAT')" class="button btn-lg p-button-text innerScreenTabBtn"></button>
        </label>
        <label for="clientdata">
          <button pButton id="clientdata" type="button" [disabled]="false" [ngClass]="(selectedTabIndex === 2 ? 'optedBtnColor' : '')" label="Client Data" (click)="getOptedTab(2, 'Client Data')" class="button btn-lg p-button-text innerScreenTabBtn"></button>
        </label>
        <label for="catdata">
          <button pButton id="catdata" type="button" [disabled]="false"  [ngClass]="(selectedTabIndex === 3 ? 'optedBtnColor' : '')" label="CAT Data" (click)="getOptedTab(3, 'CAT Data')" class="button btn-lg p-button-text innerScreenTabBtn"></button>
        </label>
        <label for="catsubmission">
          <button pButton id="catsubmission" type="button" [disabled]="false" [ngClass]="(selectedTabIndex === 4 ? 'optedBtnColor' : '')" label="CAT Submission" (click)="getOptedTab(4, 'CAT Submission')" class="button btn-lg p-button-text innerScreenTabBtn"></button>
        </label>
        <label for="catmonthlysummary">
          <button pButton id="catmonthlysummary" type="button" [disabled]="false" [ngClass]="(selectedTabIndex === 5 ? 'optedBtnColor' : '')" label="CAT Monthly Summary" (click)="getOptedTab(5, 'CAT Monthly Summary')" class="button autoWidth btn-lg p-button-text innerScreenTabBtn"></button>
        </label>
    </div>
  </div>
</div>
<br/>
<div class="col-lg-12 mt-2 p-0"></div>
@if(clientAndcatTab){
<div class="col-lg-12 nopadding">
  <div class="ui-widget-header-1">
    <div class="group-label" [ngClass]="groupListDropDown.length ? 'group-align':'text-align'"><span>Group</span></div>
    <div class="col-lg-11">
    @for(group of groupListDropDown; track group+ '-'+ $index; let i = $index) {
    <span class="nopadding">
      <label for="groupName" style="margin-top: 6px;">
        <p-button  [id]="group" type="button" [ngClass]="selectedGroup == group ? 'groupButton btn-xs active-symbol' : 'groupButton btn-xs non-active-symbol'" (click)="toggleSelectedGroupData('Group',group)">
          {{group}}
        </p-button>
      </label>
    </span>}
    </div>
  </div>
</div>
<div class="col-lg-12 mt-2 p-0"></div>
}

<!-- Client & CAT Tab -->
  <div class="col-lg-12 nopadding" [ngClass]="(!clientAndcatTab ? 'notdisplay': '')">
    @if(isClientCATDataLoadingResults){
    <div class="example-loading-shade">
      @if(isClientCATDataLoadingResults){
      <mat-spinner diameter="50"></mat-spinner>}
    </div>}
    <!-- Grid Code -->
    <p-table #dt 
      [value]="clientCATDataSet"
      [columns]="clientCATSummaryCols"
      [lazy]="true"
      appendTo="body"
      id="clientCATDataSet">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          @if(clientCATDataSet.length === 0){
          <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
            {{constantService.NO_RECORDFOUND_MSG}}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for(col of columns; track col; let headerIndex = $index) {
          <th id="columns" pResizableColumn 
           [ngClass]="{'notdisplay': ((col?.display | lowercase) == 'false'), 'cursor-pointer': true}"
           (contextmenu)="onContextMenu($event, ['Header-Comments', col, [col.field]])">
            {{col.header}}
            @if(col.count > 0){
            <span class="cellHeaderBadge cursor-pointer">{{col.count}}</span>}
          </th>}
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
        <tr [ngClass]="{'selected-row': selectRowIndex == rowIndex}">
          @for (col of columns; track col; let headerIndex = $index){
          <td (contextmenu)="onContextMenu($event, ['Field-Comments', row, [col.field]])" class="text-center bold-txt" 
          [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': ''" (click)="toggleRowSelection(rowIndex,row[col.field])">
          @if(['matched', 'differences'].includes(col.header | lowercase)){
            <span [ngClass]="row['eventMatched']==='Matched' ? 'successText' : 'failText'">
              {{row[col.field]}}
            </span>}
            @if(!['matched', 'differences'].includes(col.header | lowercase)){
            <span>
              {{row[col.field]}}
            </span>}
          </td>}
        </tr>
      </ng-template>
    </p-table>
  </div>
 
  <div class="col-lg-12 nopadding" [ngClass]="(!clientAndcatTab ? 'notdisplay': '')" >&nbsp;</div>

  <div class="col-lg-12 nopadding" [ngClass]="(!clientAndcatTab ? 'notdisplay': '')">
    @if(isClientCATDataLoadingResults){
    <div class="example-loading-shade">
    @if(isClientCATDataLoadingResults){<mat-spinner diameter="50"></mat-spinner>}
    </div>}
    <!-- Grid Code -->



<p-accordion [value]="-1">
  <p-accordion-panel value="0">
    <p-accordion-header id="AccordianTextclass">Client & CAT Details</p-accordion-header>
     <p-accordion-content class="contentClass">
        <p-table #dt 
      [value]="clientCATDetailDataSet"
      [columns]="clientCATDetailCols"
      [lazy]="true"
      appendTo="body"
      width="constantService.getResolutionWidth()"
      id="clientCATDetailDataSet">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          @if(clientCATDetailDataSet.length === 0){
          <td [attr.colspan]="columns.length" [ngClass]="'text-center'" >
            {{constantService.NO_RECORDFOUND_MSG}}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of columns; track col;let headerIndex = $index){
          <th id="columns" pResizableColumn [ngClass]="{'notdisplay': ((col?.display | lowercase) == 'false'), 'cursor-pointer': true}"
          (contextmenu)="onContextMenu($event, ['Header-Comments', col, [col.field]])">
            {{col.header}}
            @if(col.count > 0){
            <span class="cellHeaderBadge cursor-pointer">{{col.count}}</span>}
          </th>}
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
        <tr [ngClass]="'ui-widget-NoUpdated-row'">
          @for (col of columns; track col;){
          <td (contextmenu)="onContextMenu($event, ['Field-Comments', row, [col.field]])" class="bold-txt" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': (['File Name'].includes(col.header) ? 'text-left' : 'text-center')">
            <span>
              {{row[col.field]}}
            </span>
          </td>}
        </tr>
      </ng-template>
        </p-table>
     </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
  </div>
  
  <div class="col-lg-12 nopadding" [ngClass]="(!clientAndcatTab ? 'notdisplay': '')">&nbsp;</div>

  <div class="col-lg-6 nopadding-data" [ngClass]="(!clientAndcatTab ? 'notdisplay': '')" style="margin-left: 4px;">
    @if(isForUnderReportingLoadingResults){
    <div class="example-loading-shade">
    @if(isForUnderReportingLoadingResults){<mat-spinner diameter="50"></mat-spinner>}
    </div>}
    <!-- Grid Code -->
    <p-table #dt1 [value]="missingCATRecordData" [columns]="missingCATRecordsCols" [lazy]="true" appendTo="body"
      width="constantService.getResolutionWidth()" id="missingCATRecordData" styleClass="missingclientData"
      [paginator]="true" [resizableColumns]="true" alwaysShowPaginator="true"
      [totalRecords]="totalRecordsCATRecord" paginatorPosition="both" sortMode="multiple"
      [rows]="constantService.DEFAULT_ROWSIZE" [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS"
      [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION" selectionMode="single" showCurrentPageReport="true" 
      (onPage)="changePageCATREcords($event)" (onSort)="sort($event,'U')">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          @if(missingCATRecordData.length === 0){
          <td [attr.colspan]="columns.length" [ngClass]="'text-center'" >
            {{constantService.NO_RECORDFOUND_MSG}}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="caption" let-columns>
        <h4 style="text-align: center; margin-top:4px;">Under Reporting-Missing CAT Records</h4>
         <!-- Start of Quick search common component -->
        <div class="col-lg-12 widthClass">
          <app-quick-search [DefaultFilterArray]="DefaultFilterArrayForUnderReporting" [QuickSearchFilterArray]="quickFilterArrayForUnderReporting"
          (updateDefaultArray)="updateDefaultArray($event,'U')"
          (clearQuickSearch)="clearQuickSearch($event,'U')"></app-quick-search>
        </div>
          <!-- Ens of Quick search common component -->
        </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
            <th id="colCATRecordHeader" pResizableColumn [pSortableColumn]="col.field" [ngClass]="
        (col?.display | lowercase) == 'false' ? 'notdisplay' : ''">
                {{ col.header }}
                <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
        }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" [ngClass]="'ui-widget-NoUpdated-row'">
          @for (col of columns; track col;){
          <td class="bold-txt" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': (['File Name'].includes(col.header) ? 'text-left' : 'text-center')">
            @if(col.header =='OrderID'){
              <span>
                <a (click)="openOrderID('OrderID',row)" appendTo="body" style="color: blue !important;cursor: pointer">{{row[col.field]}}</a>
              </span>
            }
              @if(col.header !='OrderID'){
            <span>
              {{row[col.field]}}
            </span>
          }
          </td>}
        </tr>
      </ng-template>
       <ng-template #paginatorleft></ng-template>
      <ng-template #paginatorright>
        <app-export-to-csv [gridColumns]="MissingCATRecordsColumns" (exportToCSVListner)="exportToCSV($event,'U')"></app-export-to-csv>
        Total Records: {{missingCATRecordData.length == 0 ? 0 : totalRecordsCATRecord}}
      </ng-template>

    </p-table>
  </div>
  <div class="col-lg-6 nopadding-data" [ngClass]="(!clientAndcatTab ? 'notdisplay': '')">
    @if(isForMissingDataLoadingResults){
    <div class="example-loading-shade">
    @if(isForMissingDataLoadingResults){<mat-spinner diameter="50"></mat-spinner>}
    </div>}
    <!-- Grid Code -->
    <p-table #dt2 [value]="missingClientData" [columns]="missingClientRecordsCols" [lazy]="true" appendTo="body"
      width="constantService.getResolutionWidth()" id="missingClientRecordsCols" styleClass="missingclientData"
      [paginator]="true" [resizableColumns]="true" alwaysShowPaginator="true" 
      [totalRecords]="totalRecordsMissinClient" paginatorPosition="both" sortMode="multiple"
      [rows]="constantService.DEFAULT_ROWSIZE" [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS"
      [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION" selectionMode="single" showCurrentPageReport="true"
      (onPage)="changePageMissingRecords($event)" (onSort)="sort($event,'M')">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          @if(missingClientData.length === 0){
          <td [attr.colspan]="columns.length" [ngClass]="'text-center'" >
            {{constantService.NO_RECORDFOUND_MSG}}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="caption" let-columns style="padding: 0px; color: #232323;">
        <h4 style="text-align: center; margin-top: 4px;">Missing Client Data</h4>
        <!-- Start of Quick search common component -->
        <div class="col-lg-12 widthClass">
        <app-quick-search 
        [DefaultFilterArray]="DefaultFilterArrayForMissingData"
        [QuickSearchFilterArray]="quickFilterArrayForMissingData"
        (updateDefaultArray)="updateDefaultArray($event,'M')"
        (clearQuickSearch)="clearQuickSearch($event,'M')"></app-quick-search>
        </div>
        <!-- End of Quick search common component -->
        </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for(col of columns; track col.header + '-'+ $index; let idx = $index) {
            <th id="colClientDataHeader" pResizableColumn [pSortableColumn]="col.field" [ngClass]="
        (col?.display | lowercase) == 'false' ? 'notdisplay' : ''">
                {{ col.header }}
                <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
        }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" [ngClass]="'ui-widget-NoUpdated-row'">
          @for (col of columns; track col;){
          <td class="bold-txt" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': (['File Name'].includes(col.header) ? 'text-left' : 'text-center')">
            @if(col.header =='OrderID'){
              <span>
                <a (click)="openOrderID('OrderID',row)" appendTo="body" style="color: blue !important;cursor: pointer">{{row[col.field]}}</a>
              </span>
            }
              @if(col.header !='OrderID'){
            <span>
              {{row[col.field]}}
            </span>
          }
          </td>}
        </tr>
      </ng-template>
      <ng-template #paginatorleft></ng-template>
      <ng-template #paginatorright>
        <app-export-to-csv [gridColumns]="MissingClientRecordsColumns" (exportToCSVListner)="exportToCSV($event,'M')"></app-export-to-csv>
        Total Records: {{missingClientData.length == 0 ? 0 : totalRecordsMissinClient}}
      </ng-template>
    </p-table>
  </div>
<!-- End of Client & CAT Tab -->

<!-- Client Data Tab -->
  <div class="col-lg-12 nopadding" [ngClass]="(!clientDataTab ? 'notdisplay': '')">
    @if(isClientDataLoadingResults){
    <div class="example-loading-shade">
    @if(isClientDataLoadingResults){<mat-spinner></mat-spinner>}
    </div>}
    <!-- Grid Code -->
    <p-table #dt 
      [value]="clientDataSet"
      [columns]="clientDataCols"
      [lazy]="true"
      appendTo="body"
      id="clientDataSet">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          @if(clientDataSet.length === 0){
          <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
            {{constantService.NO_RECORDFOUND_MSG}}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of columns; track col;let headerIndex = $index){
          <th id="columns" pResizableColumn [ngClass]="{'notdisplay': ((col?.display | lowercase) == 'false'), 'cursor-pointer': true}"
         (contextmenu)="onContextMenu($event, ['Header-Comments', col, [col.field]])">
            {{col.header}}
            @if(col.count > 0){
            <span class="cellHeaderBadge cursor-pointer">{{col.count}}</span>}
          </th>}
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
        <tr [ngClass]="'ui-widget-NoUpdated-row'">
          @for (col of columns; track col;){
          <td (contextmenu)="onContextMenu($event, ['Field-Comments', row, [col.field]])" class="bold-txt" 
          [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': (col.header === 'File Name' ? 'text-left' : 'text-center')">
            <span>
              {{row[col.field]}}
            </span>
          </td>}
        </tr>
      </ng-template>
    </p-table>
  </div>
<!-- End of Client Data Tab -->

<!-- CAT Data Tab -->
  <div class="col-lg-12 nopadding" [ngClass]="(!catDataTab ? 'notdisplay': '')">
    @if(isCATDataLoadingResults){
    <div class="example-loading-shade">
    @if(isCATDataLoadingResults){<mat-spinner></mat-spinner>}
    </div>}
    @if(CATDataGroupDataSet.length > 0){
    <div class="row">
      <!-- Group Summary -->
      @for (CATDataGroup of CATDataGroupDataSet; track CATDataGroup;){
        <div class="col-lg-2 tbpadding">
          <!-- Grid Code -->
          <p-table id="CATDataGroup_groupDetail" [value]="CATDataGroup.groupDetail" [columns]="catDataGroupSummaryCols" appendTo="body">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th id="CATDataGroup" colspan="2">{{CATDataGroup.groupName}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
              @for(col of columns; track col; let headerIndex = $index) {
              <tr [ngClass]="{'notdisplay': ((col?.display | lowercase) == 'false'), 'cursor-pointer': true}">
                <td class="text-center bold-txt" (contextmenu)="onContextMenu($event, ['Header-Comments', col, [col.field],CATDataGroup.groupName])">{{col.header}}
                  @if(CATGroupByCommentCount[CATDataGroup.groupName] && CATGroupByCommentCount[CATDataGroup.groupName][0][col.field] > 0){
                  <span class="cellHeaderBadge cursor-pointer">
                    {{CATGroupByCommentCount[CATDataGroup.groupName][0][col.field]}}
                  </span>}
                </td>
                <td class="text-center bold-txt" (contextmenu)="onContextMenu($event, ['Field-Comments', row, [col.field]])">
                  <span [ngClass]="row['Matched']==='Matched' ? 'successText' : 'failText'">
                    {{row[col.field]}}
                  </span>
                </td>
              </tr>}
            </ng-template>
          </p-table>
        </div>}
      <!-- End of Group Summary -->
    </div>}
  </div>
  <div class="col-lg-12 nopadding" [ngClass]="(!catDataTab || CATDataGroupDataSet.length===0 ? 'notdisplay': '')">&nbsp;</div>

  <div class="ui-grid-col-12 nopadding table-container table-full-min-width" [ngClass]="(!catDataTab ? 'notdisplay': '')">
    @if(isCATDataLoadingResults){
    <div class="example-loading-shade">
    @if(isCATDataLoadingResults){<mat-spinner></mat-spinner>}
    </div>}
    <!-- Grid Code -->
    <p-table #dt 
      [value]="CATDataSet"
      [columns]="catDataCols"
      [lazy]="true"
      appendTo="body"
      id="CATDataSet">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          @if(CATDataSet.length === 0){
          <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
            {{constantService.NO_RECORDFOUND_MSG}}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for(col of columns; track col; let headerIndex = $index) {
          <th id="columns" pResizableColumn [ngClass]="{'notdisplay': ((col?.display | lowercase) == 'false'), 'cursor-pointer': true}"
          (contextmenu)="onContextMenu($event, ['Header-Comments', col, [col.field]])">
            {{col.header}}
            @if(col.count > 0){
            <span class="cellHeaderBadge cursor-pointer">{{col.count}}</span>}
          </th>}
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
        <tr [ngClass]="'ui-widget-NoUpdated-row'">
          @for (col of columns; track col;){
          <td (contextmenu)="onContextMenu($event, ['Field-Comments', row, [col.field]])"
          class="text-center bold-txt" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': ''">
          @if(['matched', 'differences'].includes(col.header | lowercase)){
          <span [ngClass]="row['matched']==='Matched' ? 'successText' : 'failText'">
              {{row[col.field]}}
            </span>}
            @if(!['matched', 'differences'].includes(col.header | lowercase)){
            <span>
              {{row[col.field]}}
            </span>}
          </td>}
        </tr>
      </ng-template>
    </p-table>
  </div>
  
  <div class="col-lg-12 nopadding" [ngClass]="(!catDataTab ? 'notdisplay': '')">&nbsp;</div>
<!-- End of CAT Data Tab -->

<!-- CAT Submission Tab -->

  <div class="col-lg-12 nopadding" [ngClass]="(!catSubmissionTab ? 'notdisplay': '')">
    @if(isCATSubmissionDataLoadingResults){
    <div class="example-loading-shade">
      @if(isCATSubmissionDataLoadingResults){
      <mat-spinner diameter="40"></mat-spinner>}
    </div>}
    <!-- Grid Code -->
    <p-table #dt 
      [value]="CATCorrectedDataSet"
      [columns]="correctedCATSubmissionCols"
      [lazy]="true"
      appendTo="body"
      id="CATCorrectedDataSet">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          @if(CATCorrectedDataSet.length === 0){
          <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
            {{constantService.NO_RECORDFOUND_MSG}}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for(col of columns; track col; let headerIndex = $index) {
          <th id="columns" pResizableColumn 
          [ngClass]="{'notdisplay': ((col?.display | lowercase) == 'false'), 'cursor-pointer': true}"
          (contextmenu)="onContextMenu($event, ['Header-Comments', col, [col.field]])">
            {{col.header}}
            @if(col.count > 0){
            <span class="cellHeaderBadge cursor-pointer">{{col.count}}</span>}
          </th>}
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
        <tr [ngClass]="'ui-widget-NoUpdated-row'">
          @for (col of columns; track col;){
          <td class="bold-txt"
          (contextmenu)="onContextMenu($event, ['Field-Comments', row, [col.field]])" 
          [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': (leftAlignedColumns.includes(col.header) ? 'text-left' : 'text-center')">
            <span>
              {{row[col.field]}}
            </span>
          </td>}
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="col-lg-12 nopadding" [ngClass]="(!catSubmissionTab ? 'notdisplay': '')">&nbsp;</div>
  <div class="col-lg-12 nopadding" [ngClass]="(!catSubmissionTab ? 'notdisplay': '')">
    @if(isCATSubmissionDataLoadingResults){
    <div class="example-loading-shade">
      @if(isCATSubmissionDataLoadingResults){
      <mat-spinner diameter="40"></mat-spinner>}
    </div>}
    <!-- Grid Code -->
    <p-table #dt 
      [value]="CATSubmittedDataSet"
      [columns]="submittedCATSubmissionCols"
      [lazy]="true"
      appendTo="body"
      id="CATSubmittedDataSet">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          @if(CATSubmittedDataSet.length === 0){
          <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
            {{constantService.NO_RECORDFOUND_MSG}}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for(col of columns; track col; let headerIndex = $index) {
          <th id="columns" pResizableColumn 
          [ngClass]="{'notdisplay': ((col?.display | lowercase) == 'false'), 'cursor-pointer': true}"
          (contextmenu)="onContextMenu($event, ['Header-Comments', col, [col.field]])">
            {{col.header}}
            @if(col.count > 0){
            <span class="cellHeaderBadge cursor-pointer">{{col.count}}</span>}
          </th>}
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
        <tr [ngClass]="'ui-widget-NoUpdated-row'">
          @for (col of columns; track col;){
          <td (contextmenu)="onContextMenu($event, ['Field-Comments', row, [col.field]])" class="bold-txt" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': (leftAlignedColumns.includes(col.header) ? 'text-left' : 'text-center')">
            <span>
              {{row[col.field]}}
            </span>
          </td>}
        </tr>
      </ng-template>
    </p-table>
  </div>
 
<!-- End of CAT Submission Tab -->

<!-- CAT Monthly Summary Tab -->

  <div class="col-lg-12 nopadding" [ngClass]="(!catMonthlySummaryTab ? 'notdisplay': '')">
    @if(previousMonths.length > 0){
    <div class="ui-widget-header-1 nopadding">
      @for(prevMonth of previousMonths; track prevMonth + '-'+ $index; let i = $index) {
      <span>
        <button [id]="'Month_' + i" pButton type="button" class="ui-button-info monthBtn" [ngClass]="(selectedPrevMonth === prevMonth ? 'optedBtnColor' : '')" (click)="getOptedMonthDates(prevMonth)">{{prevMonth}}</button>
      </span>}
    </div>}
    @if(isCATMonthlySummaryDataLoadingResults){
    <div class="example-loading-shade">
      @if(isCATMonthlySummaryDataLoadingResults){
      <mat-spinner diameter="50"></mat-spinner>}
    </div>}
    <div class="col-lg-12 nopadding">
      <div class="ui-dialog-buttonpane ui-helper-clearfix float-right pad-2">
        <button id="export-btn" matTooltip="Export" [matTooltipShowDelay]="1000" class="exportBtn" (click)="exportCATMonthlySummaryToCSV();" type="button">
          Export <i class="fa fa-download" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <!-- CAT Monthly Finra Submission Counts -->
      <div class="col-lg-6">
        <p-table #dt 
          [value]="CATMonthlySummaryDataSet" 
          [columns]="catMonthlyFinraSubmissionSummaryCols"
          [lazy]="true"
          appendTo="body"
          id="CATMonthlyFinraSubmissionSummaryDataSet">
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                @if(CATMonthlySummaryDataSet.length === 0){
                <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
                  {{constantService.NO_RECORDFOUND_MSG}}
                </td>}
              </tr>
            </ng-template>

            <ng-template pTemplate="header" let-columns>
              <tr>
                @for (col of columns.slice(0,1); track col;){
                <th id="columns" pResizableColumn rowspan="3"
                  [ngClass]="{'notdisplay': ((col.display | lowercase) == 'false'), 'cursor-pointer': true}"
                  (contextmenu)="onContextMenu($event, ['Header-Comments', null, [col.field]])">
                  {{col.header}}
                  @if(col.count > 0){
                  <span class="cellHeaderBadge cursor-pointer">{{col.count}}</span>}
                </th>}
              </tr>
              <tr>
                <th id="CAT" colspan="5">FINRA CAT Submission Count</th>
              </tr>
              <tr>
                @for (col of columns.slice(1,columns.length); track col;){
                <th id="columns" pResizableColumn [ngClass]="{'notdisplay': ((col?.display | lowercase) == 'false'), 'cursor-pointer': true}"
                (contextmenu)="onContextMenu($event, ['Header-Comments', col, [col.field]])">
                  {{col.header}}
                  @if(col.count > 0){
                  <span class="cellHeaderBadge cursor-pointer">{{col.count}}</span>}
                </th>}
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
              <tr [ngClass]="'ui-widget-NoUpdated-row'">
                @for(col of columns; track col; let columnIndex = $index) {
                <td [ngClass]="{'notdisplay': (col?.display | lowercase) == 'false', 'text-center': true}"
                  (contextmenu)="onContextMenu($event, ['Field-Comments', row, [col.field]])">
                  <span>
                    {{(columnIndex===0 ? row[col.field] : row[col.field] | number)}}
                  </span>
                </td>}
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr>
                <td class="text-center"><strong>Totals</strong></td>
                <td class="text-center"></td>
                <td class="text-center"><strong>{{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalBAURecordCount) ? (CATMonthlySummaryTotals.totalBAURecordCount | number) : 0}}</strong></td>
                <td class="text-center"></td>
                <td class="text-center"><strong>{{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalRepairRecordCount) ? (CATMonthlySummaryTotals.totalRepairRecordCount | number) : 0}}</strong></td>
              </tr>
            </ng-template>
        </p-table>
      </div>
    <!-- End of CAT Monthly Finra Submission Counts -->
    <!-- CAT Monthly Finra Rejection Counts -->
      <div class="col-lg-6">
        <p-table #dt 
          [value]="CATMonthlySummaryDataSet" 
          [columns]="catMonthlyFinraRejectionSummaryCols"
          [lazy]="true"
          appendTo="body"
          id="CATMonthlyFinraRejectionSummaryDataSet">
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                @if(CATMonthlySummaryDataSet.length === 0){
                <td [attr.colspan]="columns.length" [ngClass]="'text-center'">
                  {{constantService.NO_RECORDFOUND_MSG}}
                </td>}
              </tr>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th id="exceptionHeader" colspan="5" [ngClass]="'exceptionHeader'">Open FINRA Rejection Count</th>
              </tr>
              <tr>
                @for (col of columns; track col;){
                <th id="columns" pResizableColumn [ngClass]="{'notdisplay': ((col?.display | lowercase) == 'false'), 'cursor-pointer': true, 'exceptionHeader': true}"
                (contextmenu)="onContextMenu($event, ['Header-Comments', col, [col.field]])">
                  {{col.header}}
                  @if(col.count > 0){
                  <span class="cellHeaderBadge cursor-pointer">{{col.count}}</span>}
                </th>}
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
              <tr [ngClass]="'ui-widget-NoUpdated-row'">
                @for(col of columns; track col; let i = $index) {
                <td [ngClass]="{'notdisplay': (col?.display | lowercase) == 'false', 'text-center': true}"
                  (contextmenu)="onContextMenu($event, ['Field-Comments', row, [col.field]])">
                  @if((row[col.field] === 0)){
                  <span>
                    {{row[col.field] | number}}
                  </span>}
                  @if((row[col.field] > 0)){
                  <span>
                    <a matTooltip="View Finra Exception Details" [matTooltipShowDelay]="1000" appendTo="body" 
                      [id]="col.field + '_'+ i" (click)="goToFinraExceptionViewer(row['reportDate'], col.label, row[col.field], row[col.label+'-ExceptionCodes'])" [class]="'text-blue'">
                      {{row[col.field] | number }}
                    </a>
                  </span>}
                </td>}
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr>
                    <td class="text-center">
                      @if((CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalWarningCount === 0)){
                      <strong>{{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalWarningCount) ? (CATMonthlySummaryTotals.totalWarningCount | number) : 0}}</strong>}
                      @if((CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalWarningCount > 0)){
                      <strong>
                        <a matTooltip="View Finra Exception Details" [matTooltipShowDelay]="1000" appendTo="body" 
                          [id]="'totalWarningCount'" (click)="goToFinraExceptionViewer(null, 'Warning', CATMonthlySummaryTotals.totalWarningCount, CATMonthlySummaryTotals['all-Warning-ExceptionCodes'])" [class]="'text-blue'">
                          {{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalWarningCount) ? (CATMonthlySummaryTotals.totalWarningCount | number) : 0}}
                        </a>
                      </strong>}
                    </td>
                    <td class="text-center">
                      @if((CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalIngestionCount === 0)){
                      <strong>{{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalIngestionCount) ? (CATMonthlySummaryTotals.totalIngestionCount | number) : 0}}</strong>}
                      @if((CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalIngestionCount > 0)){ 
                      <strong>
                        <a matTooltip="View Finra Exception Details" [matTooltipShowDelay]="1000" appendTo="body" 
                          [id]="'totalIngestionCount'" (click)="goToFinraExceptionViewer(null, 'Ingestion', CATMonthlySummaryTotals.totalIngestionCount, CATMonthlySummaryTotals['all-Ingestion-ExceptionCodes'])" [class]="'text-blue'">
                          {{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalIngestionCount) ? (CATMonthlySummaryTotals.totalIngestionCount | number) : 0}}
                        </a>
                      </strong>}
                    </td>
                    <td class="text-center">
                      @if((CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalIntrafirmCount === 0)){
                      <strong>{{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalIntrafirmCount) ? (CATMonthlySummaryTotals.totalIntrafirmCount | number) : 0}}</strong>}
                      @if((CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalIntrafirmCount > 0)){
                      <strong>
                        <a matTooltip="View Finra Exception Details" [matTooltipShowDelay]="1000" appendTo="body" 
                          [id]="'totalIntrafirmCount'" (click)="goToFinraExceptionViewer(null, 'Intra-Firm', CATMonthlySummaryTotals.totalIntrafirmCount, CATMonthlySummaryTotals['all-Intra-Firm-ExceptionCodes'])" [class]="'text-blue'">
                          {{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalIntrafirmCount) ? (CATMonthlySummaryTotals.totalIntrafirmCount | number) : 0}}
                        </a>
                      </strong>}
                    </td>
                    <td class="text-center">
                      @if((CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalInterfirmCount === 0)){
                      <strong>{{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalInterfirmCount) ? (CATMonthlySummaryTotals.totalInterfirmCount | number) : 0}}</strong>}
                      @if((CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalInterfirmCount > 0)){
                      <strong>
                        <a matTooltip="View Finra Exception Details" [matTooltipShowDelay]="1000" appendTo="body" 
                          [id]="'totalInterfirmCount'" (click)="goToFinraExceptionViewer(null, 'Inter-Firm', CATMonthlySummaryTotals.totalInterfirmCount, CATMonthlySummaryTotals['all-Inter-Firm-ExceptionCodes'])" [class]="'text-blue'">
                          {{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.totalInterfirmCount) ? (CATMonthlySummaryTotals.totalInterfirmCount | number) : 0}}
                        </a>
                      </strong>}
                    </td>
                    <td class="text-center">
                      @if((CATMonthlySummaryTotals && CATMonthlySummaryTotals.overAllExceptionCount === 0)){
                      <strong>{{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.overAllExceptionCount) ? (CATMonthlySummaryTotals.overAllExceptionCount | number) : 0}}</strong>}
                      @if((CATMonthlySummaryTotals && CATMonthlySummaryTotals.overAllExceptionCount > 0)){
                      <strong>
                        <a matTooltip="View Finra Exception Details" [matTooltipShowDelay]="1000" appendTo="body" 
                          [id]="'totalExceptionCount'" (click)="goToFinraExceptionViewer(null, 'Overall', CATMonthlySummaryTotals.overAllExceptionCount, CATMonthlySummaryTotals['all-Total-ExceptionCodes'])" [class]="'text-blue'">
                          {{(CATMonthlySummaryTotals && CATMonthlySummaryTotals.overAllExceptionCount) ? (CATMonthlySummaryTotals.overAllExceptionCount | number) : 0}}
                        </a>
                      </strong>}
                    </td>
                </tr>
            </ng-template>
        </p-table>
      </div>
    <!-- End of CAT Monthly Finra Rejection Counts -->
  </div>
  <div class="col-lg-12 nopadding" [ngClass]="(!catMonthlySummaryTab ? 'notdisplay': '')">&nbsp;</div>

  <!-- End of CAT Monthly Summary -->

<!-- Context Menu on every Table Field -->

<!-- End of Context Menu on every Table Field -->

<!-- CAT Recon Comments -->
@if(selectedRowData && selectedRowData.commentSection && selectedRowData.commentSection.length > 0
&& selectedRowData != undefined){ 
<app-cat-recon-comment-viewer 
  (reloadCommentCount)="getAllCommentCounts()"
  [selectedRow]="selectedRowData"
  [selectedTabIndex]="selectedTabIndex"
  [tableName]="tableName"
  [groupName]="selectedGroup">
</app-cat-recon-comment-viewer>
 }

<!-- Confirmation Dialogue -->
<p-confirmDialog 
  id="catReconComfirmation"
  acceptLabel="Ok" 
  key="informationDialoge" 
  [rejectVisible]="false" 
  appendTo="body" 
  header="Information" 
  icon="pi pi-exclamation-triangle" 
  [baseZIndex]="999999">
</p-confirmDialog>